export default __webpack_public_path__ + "static/media/EIpiXh3XUAAhxyV.95eb63cb.png";